const defaultVariables = [
	"name",
	"email",
	"phone",
	"contacttoken",
	"typechat",
	"whatsappassigned",
	"day",
	"hour",
	"minute",
	"typeMinute",
	"channelType",
	"igResponseType",
	"metaUsername",
	"lastMessageType",
	"lastMessageText",
	"contactId",
	"whatsapp_bsuid",
	"input",
];

export { defaultVariables };
